module.exports = __webpack_public_path__ + "static/delhi-4bf867134aed23f0726dc55626b5983b.png";